import {sortByKey} from 'presentation/utils';
import {makeGetHealthDistricts} from 'main/factories/usecases/private/booking-flow/remote-health-booking/get-health-districts-factory';
import {GetHealthDistrictsParams} from 'domain/usecases/private/booking-flow/health/get-health-districts';

async function getHealthDistricts(params: GetHealthDistrictsParams) {
	const districts = await makeGetHealthDistricts().get(params);

	const districtsSorted = sortByKey(districts?.content || [], 'district');

	return districtsSorted;
}

export {getHealthDistricts};
